<section class="masthead montserrat">
    <div class="container">
        <img class="lazyload" data-src="./assets/logo.svg" alt="Leone Lifestyle - LA NUOVA ERA DELLA NUTRIZIONE E DEL BENESSERE" width="100%" height="300px">
        <div class="txt text-center">LA NUOVA ERA DELLA<br>NUTRIZIONE E DEL BENESSERE</div>
        <div class="downarrow marginauto my-3 py-3"></div>
    </div>
</section>

<section class="grey mb-5 montserrat">
    <div class="textblock wrapper marginauto">
        <div class="col-12">
            <!-- <div class="divider w-50 marginauto"></div> -->
        </div>

        <div class="col-11 py-5 marginauto">
            <div class="text title">
                NUTRIZIONE E DIETA CHETOGENICA
                <div class="span">Per essere artefici del cambiamento e del benessere!</div>
            </div>
        </div>
    </div>
</section>

<section class="textblock wrapper marginauto montserrat">
    <div class="col-11 mt-3 marginauto">
        <div class="text text-justify pb-3">
            <p>È una gestualità che ripetiamo solitamente più volte al giorno, risponde ad un istinto di sopravvivenza irrinunciabile e deve essere il più possibile piacevole e salutare. Molto di questa gestualità dipende dall'educazione, da come siamo stati abituati fin da bambini a relazionarci con questo o con quell'altro alimento; appagamento, consolazione, premio sono tra i principali meccanismi psico-comportamentali che hanno rinforzato i circuiti neurologici delle dipendenze da carboidrati e sui quali si è radicato un comportamento alimentare tanto diffuso quanto dannoso.</p>

            <p>Questo ha favorito spesso abitudini più che mai deleterie, viviamo immersi nel trionfo del junk-food, dei cibi ultra processati, degli zuccheri nascosti; l'uomo contemporaneo paladino di un messaggio ecologico globale, dichiara e grida ai più alti consessi lo stop all'inquinamento e agli abusi in tutte le sue forme, in pratica poi si diffonde un timido consiglio di ridurre gli zuccheri aggiunti ma nulla accade di sostanziale.</p>

            <p>Basta guardarsi attorno per vedere che siamo in un mondo dove sovrappeso, obesità, infiammazione, tossicità e tutte le malattie correlate a questi fattori procurano danni incalcolabili alla salute di moltissimi, tutto direttamente e indirettamente riconducibile a scorrette scelte alimentari.</p>
        </div>
    </div>
</section>

<section class="middlebg montserrat">
    <img class="lazyload" data-src="./assets/bg-middle.jpg" alt="Leone Lifestyle">
</section>

<section class="mb-3 textblock wrapper marginauto montserrat">
    <div class="col-11 mt-3 marginauto">
        <div class="text text-justify pt-3">
            <p>Ebbene non attendiamo immobili cambiamenti sostanziali perché questi non avverranno; è uno dei pochi casi in cui possiamo veramente decidere di noi, se tutte le volte che ci avviciniamo al cibo vogliamo farci del bene oppure vogliamo farci del male.</p>

            <p style="font-weight: bold;">Gli schemi nutrizionali attuali hanno fallito e la ricerca scientifica mondiale conferma ogni giorno la validità della nutrizione chetogenica e della dieta chetogenica per il benessere, in molti casi come vera e propria terapia medica si unisce a questo un numero ormai incalcolabile di persone che ne hanno tratto beneficio e che continuano così a mantenersi in piena salute.</p>

            <p>Per chi possa farlo e siamo in molti, scegliere come alimentarsi e proiettarsi verso un orizzonte “low-carb” è possibile, bisogna volerlo e attuarlo; abbracciamo il più possibile questa nuova era, il vero cambiamento nutrizionale verso il <strong>ben-essere</strong> è solamente dentro di noi.</p>

            <p class="text-xl-right text-lg-right text-md-right text-sm-center text-center pt-3 font-weight-bold">Riccardo Ferrero Leone</p>
            <div class="round-img float-xl-right float-lg-right float-md-right float-sm-none float-none"></div>
            <div class="clearfix"></div>
        </div>
    </div>
</section>

<section class="my-5 montserrat">
    <div class="textblock wrapper marginauto">
        <div class="divider w-50 marginauto"></div>
    </div>
</section>

<section class="grey mb-5 montserrat">
    <div class="textblock wrapper marginauto">

        <div class="col-11 py-5 marginauto">
            <div class="text title">
                SCOPRI LA DIETA CHETOGENICA
            </div>

            <div class="text text-justify pt-3">
                <p>Ci sono tante persone che mangiano di tutto e liberamente, sono in buona forma fisica, analisi di laboratorio e esami clinici perfetti (del medico di fiducia non ricordano neanche il nome!) e non si pongono il problema di come e cosa mangiare semplicemente perché questo problema non lo conoscono, beati loro diremo!</p>

                <p class="float-right">
                    <a class="btn btn-primary mx-2 my-sm-2 my-2" routerLink="/protocollo-chetogenico" routerLinkActive="router-link-active">
                        Scopri il Protocollo L-Amino
                    </a>

                    <a class="btn btn-primary mx-2 my-sm-2 my-2" routerLink="/dieta-chetogenica" routerLinkActive="router-link-active">
                        Scopri la Dieta Chetogenica
                    </a>
                </p>

                <div class="clearfix"></div>

            </div>
        </div>

    </div>
</section>

<section class="my-5 montserrat">
    <div class="textblock wrapper marginauto">
        <div class="divider w-50 marginauto"></div>
    </div>
</section>

<section class="montserrat">
    <div class="textblock wrapper marginauto">
        <div class="col-11 marginauto">
            <div class="row">
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 text title shop-text text-xl-left text-lg-left text-md-left text-sm-center text-center">
                    IN EVIDENZA
                </div>
            </div>
        </div>
    </div>
</section>

<section class="textblock wrapper marginauto montserrat blog pb-4">
    <div class="row marginauto">

        <div *ngFor="let homeTopic of homeTopics" class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12 pb-4">
            <div class="card">

                <a class="text title" routerLink="{{ homeTopic.url }}">
                    <img class="lazyload card-img-top" [src]="homeTopic.src" [alt]="homeTopic.title" [title]="homeTopic.title">
                </a><br>

                <div class="card-body text-small">
                    <div class="card-text-height">
                        <span [innerHTML]="homeTopic.desc"></span>
                    </div>

                    <div class="clearfix my-3"></div>

                    <div class="float-xl-right float-lg-right float-md-none float-sm-none float-right">
                        <a routerLink="{{ homeTopic.url }}" class="btn btn-primary">{{ homeTopic.cta }}</a>
                    </div>

                    <div class="clearfix"></div>
                </div>
            </div>
        </div>

    </div>
</section>

<section class="textblock wrapper marginauto montserrat blog">
    <div class="row marginauto">

        <div *ngFor="let homeTopic_riga2 of homeTopics_riga2" class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
            <div class="text title py-3" routerLink="{{ homeTopic_riga2.url }}">{{ homeTopic_riga2.name }}</div>
            <div class="card">

                <a class="text title" routerLink="{{ homeTopic_riga2.url }}">
                    <img class="lazyload card-img-top" [src]="homeTopic_riga2.src" [alt]="homeTopic_riga2.title" [title]="homeTopic_riga2.title">
                </a><br>

                <div class="card-body text-small">
                    <div class="card-text-height">
                        <span [innerHTML]="homeTopic_riga2.desc"></span>
                    </div>

                    <div class="clearfix my-3"></div>

                    <div class="float-xl-right float-lg-right float-md-none float-sm-none float-right">
                        <a routerLink="{{ homeTopic_riga2.url }}" class="btn btn-primary">{{ homeTopic_riga2.cta }}</a>
                    </div>

                    <div class="clearfix"></div>
                </div>
            </div>
        </div>

    </div>
</section>

<section class="my-5 montserrat">
    <div class="textblock wrapper marginauto">
        <div class="divider w-50 marginauto"></div>
    </div>
</section>

<section class="mainblock grey montserrat">
    <div class="wrapper marginauto">
        <div class="row no-gutters">

            <div *ngFor="let homePhoto of homePhotos" class="col-xl-4 col-lg-4 col-md-4 col-sm-11 col-11 marginauto">
                <div class="title py-3">{{ homePhoto.name }}</div>
                <div class="row no-gutters">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 marginauto no-gutters">
                        <img class="lazyload" [src]="homePhoto.src" [alt]="homePhoto.title" [title]="homePhoto.title" width="100%">
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<section class="my-5 montserrat">
    <div class="textblock wrapper marginauto">
        <div class="divider w-50 marginauto"></div>
    </div>
</section>

<section class="montserrat">
    <div class="textblock wrapper marginauto">
        <div class="col-11 marginauto">
            <div class="row">
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 text title shop-text text-xl-left text-lg-left text-md-left text-sm-center text-center">
                    LEGGI IL NOSTRO BLOG
                </div>
            </div>
        </div>
    </div>
</section>

<section class="textblock wrapper marginauto montserrat blog">
    <div class="card-columns col-12 marginauto">

        <div *ngFor="let homeArticle of homeArticles">
            <div class="card">

                <a class="text title" routerLink="{{ homeArticle.url }}">
                    <img class="lazyload card-img-top" [src]="homeArticle.src" [alt]="homeArticle.alt" [title]="homeArticle.title">
                </a><br>

                <div class="card-body">
                    <div class="card-text-height_">
                        <a class="text title" href="{{ homeArticle.url }}">{{ homeArticle.title }}</a>

                        <div class="row mt-2">
                            <div class="col">
                                <span [innerHTML]="homeArticle.author" class="badge badge-pill badge-warning title-spacer py-xl-1 py-lg-1 py-md-2 py-sm-2 py-2"></span>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-12">
                                <span class="badge badge-pill badge-secondary">{{ homeArticle.section }}</span>
                            </div>

                            <div class="col-12">
                                <span class="badge badge-pill badge-secondary">{{ homeArticle.section_1 }}</span>
                            </div>

                            <div class="col-12">
                                <span class="mb-5 badge badge-pill badge-secondary">{{ homeArticle.section_2 }}</span>
                            </div>

                        </div>
                    </div>

                    <div class="float-xl-right float-lg-right float-md-none float-sm-none float-right">
                        <a routerLink="{{ homeArticle.url }}" class="btn btn-primary">Leggi l'articolo</a>
                    </div>

                    <div class="clearfix"></div>

                </div>
            </div>
        </div>

    </div>
</section>

<section class="my-5 montserrat">
    <div class="textblock wrapper marginauto">
        <div class="divider w-50 marginauto"></div>
    </div>
</section>

<section class="mb-5 montserrat">
    <div class="textblock wrapper marginauto">
        <div class="col-11 marginauto">
            <div class="row">
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 text title shop-text text-xl-left text-lg-left text-md-left text-sm-center text-center">
                    SCOPRI IL NOSTRO SHOP
                </div>
                <!-- <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 shop-logo marginauto"></div> -->
            </div>
        </div>
    </div>
</section>

<section class="videosection montserrat wrapper marginauto">
    <div class="videocontainier col-11 marginauto">
        <owl-carousel-o [options]="customOptions" class="carousel marginauto">
            <ng-container *ngFor="let slide of clients">
                <ng-template carouselSlide [id]="slide.id">
                    <a href="{{ slide.url }}" target="_blank">
                        <img class="lazyload" [src]="slide.src" [alt]="slide.title" [title]="slide.title">
                    </a>

                    <!-- <div>
                        <img class="lazyload" [src]="slide.src" [alt]="slide.title" [title]="slide.title">
                    </div> -->

                </ng-template>
            </ng-container>
        </owl-carousel-o>
    </div>

    <div class="videocontainier-mobile col-12">
        <div *ngFor="let slide of clients" class="pb-3">
            <a href="{{ slide.url }}" target="_blank">
                <img class="lazyload" [src]="slide.src" [alt]="slide.alt" [title]="slide.title">
            </a>

            <!-- <div>
                <img class="lazyload" [src]="slide.src" [alt]="slide.alt" [title]="slide.title">
            </div> -->

        </div>
    </div>
</section>
